import { render, staticRenderFns } from "./FeedBackVue.vue?vue&type=template&id=626d64dd&scoped=true"
import script from "./FeedBackVue.vue?vue&type=script&lang=js"
export * from "./FeedBackVue.vue?vue&type=script&lang=js"
import style0 from "./FeedBackVue.vue?vue&type=style&index=0&id=626d64dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626d64dd",
  null
  
)

export default component.exports